
import styles from './Soglasie.module.css'

export const Soglasie = () => {
    return ( 
        <div className={styles.Soglasie}>
            <div className={styles.container}>
      <div className={styles.document}>
        <div className={styles.header}>         
          <div className={styles.headerInfo}>
            <div className={styles.projectName}>Школа поддержки инклюзии</div>
            <div className={styles.hashtag}>#ЗАОДНОДОБРО</div>
            <div className={styles.university}>Проект Российского государственного</div>
            <div className={styles.university}>университета социальных технологий</div>
          </div>
        </div>
        
        <h1 className={styles.documentTitle}>
          СОГЛАСИЕ<br />на обработку персональных данных
        </h1>
        
        <div className={styles.clause}>
          <div className={styles.clauseTitle}>
            Настоящим я, далее -- <span className={styles.highlight}>«Субъект персональных данных»</span>,
          </div>
          <div className={styles.clauseContent}>
            во исполнение требований Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данных» свободно, своей волей и в своем интересе даю федеральному государственному бюджетному образовательному учреждению инклюзивного высшего образования «Российский государственный университет социальных технологий», расположенному по адресу: 107150, г. Москва, ул. Лосиноостровская, д. 49, далее -- <span className={styles.highlight}>«Оператор»</span>, согласие на обработку своих персональных данных, указанных:
            
            <ul className={styles.list}>
              <li className={styles.listItem}>
                при регистрации путем заполнения заявки (веб-формы) на интернет-сайте <a href="https://заодно.team/" className={styles.url} target="_blank" rel="noopener noreferrer">https://заодно.team/</a> (далее -- сайт), и (или)
              </li>
              <li className={styles.listItem}>
                при подписании иных анкет, заявлений для участия в Школе поддержки инклюзии #ЗАОДНО Добро (далее -- Школа), который проводится Оператором или уполномоченным Оператором лицом, и (или)
              </li>
              <li className={styles.listItem}>
                при оставлении заявки на участие в Школе и иных веб-форм на сайте, либо при направлении информации с использованием сайта.
              </li>
            </ul>
          </div>
        </div>
        
        <div className={styles.clause}>
          <div className={styles.clauseTitle}>
            Я согласен(согласна), что под моими персональными данными понимается любая информация, относящаяся ко мне как к субъекту персональных данных, в том числе
          </div>
          <div className={styles.clauseContent}>
            <ul className={styles.subList}>
              <li className={styles.subListItem}>
                фамилия, имя, отчество, адрес места жительства (по регистрации и фактический);
              </li>
              <li className={styles.subListItem}>
                контактные данные (номер мобильного телефона, адрес электронной почты);
              </li>
              <li className={styles.subListItem}>
                любые иные данные обо мне, которые станут известны в ходе участия в Школе, а также иная информация обо мне, которая сообщается мной Оператору.
              </li>
            </ul>
          </div>
        </div>
        
        <div className={styles.clause}>
          <div className={styles.clauseTitle}>
            Указанные мной персональные данные предоставляются в целях участия в Школе, проводимой Оператором, обеспечения соблюдения законов РФ и иных нормативных правовых актов, в целях получения информации в рамках участия в Школе, путем осуществления прямых контактов со мной с помощью средств связи и (или) по иным контактным данным.
          </div>
        </div>
        
        <div className={styles.clause}>
          <div className={styles.clauseTitle}>
            Я выражаю свое согласие на осуществление Оператором обработки моих персональных данных: осуществление любого действия (операции) или совокупности действий (операций), совершаемых с использованием средств автоматизации или без использования таких средств с моими персональными данными, включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (распространение, предоставление, доступ), обезличивание, блокирование, удаление, уничтожение моих персональных данных, передачу моих персональных данных иным третьим лицам (обеспечивая при этом принятие такими лицами соответствующих обязательств в части конфиденциальности персональных данных), получение, обработку, хранение, уточнение (обновление, изменение), обезличивание, блокирование, удаление, уничтожение моих персональных данных путем ведения баз данных автоматизированным, механическим, ручным способами в целях:
          </div>
          <div className={styles.clauseContent}>
            <ul className={styles.subList}>
              <li className={styles.subListItem}>
                организации и проведения Школы поддержки инклюзии #ЗАОДНО Добро;
              </li>
              <li className={styles.subListItem}>
                ведения и поддержания в актуальном состоянии базы данных участников Школы;
              </li>
              <li className={styles.subListItem}>
                получения и исследования данных об итогах Школы;
              </li>
              <li className={styles.subListItem}>
                постоянного совершенствования Оператором уровня проведения Школы;
              </li>
              <li className={styles.subListItem}>
                информирования меня о предлагаемых Оператором услугах, проводимых мероприятиях, и т.д.
              </li>
            </ul>
          </div>
        </div>
        
        {/* Остальные пункты согласия (пункты 5-14) */}
        <div className={styles.clause}>
          <div className={styles.clauseTitle}>
            Я выражаю согласие на получение информационных и новостных рассылок, приглашений на мероприятия, проводимые федеральным государственным бюджетным образовательным учреждением инклюзивного высшего образования «Российский государственный университет социальных технологий» и другой информации новостного содержания и разрешаю Оператору направлять в мой адрес SMS-сообщения, уведомления на мой адрес электронной почты, а также иные виды уведомлений с использованием любых средств связи, в том числе посредством использования телефонной связи, электронных средств связи (включая SMS-сообщения), а также почтовой и других средств связи.
          </div>
        </div>
        
        <div className={styles.clause}>
          <div className={styles.clauseTitle}>
            Я выражаю согласие и разрешаю Оператору объединять мои персональные данные в информационную систему персональных данных и обрабатывать мои персональные данные с помощью средств автоматизации либо без использования средств автоматизации, а также с помощью иных программных средств, специально разработанных Оператором или по его поручению третьими лицами.
          </div>
        </div>
        
        <div className={styles.clause}>
          <div className={styles.clauseTitle}>
            Настоящим я уведомлен(а) Оператором о том, что предполагаемыми пользователями моих персональных данных являются работники Оператора, а также лица, привлеченные Оператором на условиях гражданско-правового договора, а также иные лица (в т.ч. их работники), которым Оператор поручил обработку моих персональных данных.
          </div>
        </div>
        
        <div className={styles.clause}>
          <div className={styles.clauseTitle}>
            Я ознакомлен(а) с тем, что настоящее согласие на обработку моих персональных данных и информации вступает в силу со дня его подписания и действует до дня отзыва посредством направления в адрес Оператора, указанный в пункте 1 настоящего согласия, заявления в простой письменной форме в соответствии с требованиями законодательства Российской Федерации.
          </div>
        </div>
        
        <div className={styles.clause}>
          <div className={styles.clauseTitle}>
            Датой отзыва считается день, следующий за днём вручения Оператору письменного заявления об отзыве согласия на обработку персональных данных.
          </div>
        </div>
        
        <div className={styles.clause}>
          <div className={styles.clauseTitle}>
            Я имею право на доступ к своим персональным данным, право требовать уточнения (обновления, изменения) моих персональных данных, а также удаления и уничтожения моих персональных данных в соответствии с требованиями законодательства Российской Федерации.
          </div>
        </div>
        
        <div className={styles.clause}>
          <div className={styles.clauseTitle}>
            Я обязуюсь в случае изменения моих персональных данных незамедлительно сообщать об этом Оператору, с предоставлением подтверждающих документов.
          </div>
        </div>
        
        <div className={styles.clause}>
          <div className={styles.clauseTitle}>
            Настоящее Согласие признается мной, Оператором моим письменным согласием на обработку моих персональных данных и информации, данным согласно ст. 9 Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данных».
          </div>
        </div>
        
        <div className={styles.clause}>
          <div className={styles.clauseTitle}>
            Настоящим согласием я подтверждаю, что являюсь субъектом предоставляемых персональных данных, а также подтверждаю достоверность предоставляемых данных.
          </div>
        </div>
        
        <div className={styles.clause}>
          <div className={styles.clauseTitle}>
            Я осознаю, что заполнение заявки, подписание анкеты (анкет), заполнение веб-форм на сайте, регистрация на сайте и (или) осуществление мной иных действий, указанных в п. 1 настоящего согласия, означает, что мной дано настоящее согласие на обработку моих персональных данных, а также означает мое письменное согласие с условиями, описанными в настоящем согласии.
          </div>
        </div>
        
        
      </div>
    </div>
        </div>
    );
}